import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import type { EventContentArg } from "@fullcalendar/core";
import CustomIcon from "../../../../../../../public/icons-v1_1";

interface Props {
  eventInfo: EventContentArg;
  selectedUnoFeeId?: number;
}

// FullCalendar 이벤트 셀의 커스텀 렌더링 컴포넌트
function CalendarEventContent({ eventInfo, selectedUnoFeeId }: Props) {
  const unoFeeId = eventInfo.event.id;
  const { isBillingDate, hasCarriedOver } = eventInfo.event.extendedProps;
  const isSelected =
    !!selectedUnoFeeId && String(selectedUnoFeeId) === unoFeeId;

  if (isBillingDate) {
    return (
      <Text className="billing-date-event" color={"#CC1D1D"}>
        {eventInfo.event.title}
      </Text>
    );
  }

  return (
    <Flex
      alignItems="center"
      gap="4px"
      justifyContent="center"
      cursor={"pointer"}
      backgroundColor={isSelected ? "#E2F8FF" : "#F7F9FA"}
      borderRadius={"4px"}
      width={"100%"}
      _hover={{
        background: isSelected ? "#E2F8FF" : "#EFEFED",
      }}
      _active={{
        background: isSelected ? "#E2F8FF" : "#D4D4D1",
      }}
    >
      {hasCarriedOver && (
        <CustomIcon
          src={"warning-circle-solid"}
          width={16}
          height={16}
          color={"#E5B400"}
        />
      )}
      <Text color={isSelected ? "#1272EF" : "#444444"}>
        {eventInfo.event.title}
      </Text>
    </Flex>
  );
}

export default CalendarEventContent;
